export const ADD_UDHAR_REQUEST = "ADD_UDHAR_REQUEST";
export const ADD_UDHAR_SUCCESS = "ADD_UDHAR_SUCCESS";
export const ADD_UDHAR_FAIL = "ADD_UDHAR_FAIL";
export const ADD_UDHAR_RESET = "ADD_UDHAR_RESET";

export const GET_UDHAR_REQUEST = "GET_UDHAR_REQUEST";
export const GET_UDHAR_SUCCESS = "GET_UDHAR_SUCCESS";
export const GET_UDHAR_FAIL = "GET_UDHAR_FAIL";

export const GET_SINGLE_UDHAR_REQUEST = "GET_SINGLE_UDHAR_REQUEST";
export const GET_SINGLE_UDHAR_SUCCESS = "GET_SINGLE_UDHAR_SUCCESS";
export const GET_SINGLE_UDHAR_FAIL = "GET_SINGLE_UDHAR_FAIL";

export const UPDATE_UDHAR_REQUEST = "UPDATE_UDHAR_REQUEST";
export const UPDATE_UDHAR_SUCCESS = "UPDATE_UDHAR_SUCCESS";
export const UPDATE_UDHAR_FAIL = "UPDATE_UDHAR_FAIL";
export const UPDATE_UDHAR_RESET = "UPDATE_UDHAR_RESET";

export const DELETE_UDHAR_REQUEST = "DELETE_UDHAR_REQUEST";
export const DELETE_UDHAR_SUCCESS = "DELETE_UDHAR_SUCCESS";
export const DELETE_UDHAR_FAIL = "DELETE_UDHAR_FAIL";
export const DELETE_UDHAR_RESET = "DELETE_UDHAR_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS"; 